import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs';
import { readApiErrorBlob } from './api-error';

// Decode download errors for local handlers without introducing global toasts.
export const apiErrorInterceptor: HttpInterceptorFn = (request, next) =>
    next(request).pipe(catchError(async (error: unknown) => {
        if (!(error instanceof HttpErrorResponse)) throw error;
        const payload = await readApiErrorBlob(error.error);
        if (payload === error.error) throw error;
        throw new HttpErrorResponse({
            error: payload, headers: error.headers, status: error.status,
            statusText: error.statusText, url: error.url ?? undefined,
        });
    }));
